import React, { Component } from 'react';
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import AnnonceCard from '../common/Hebergement/AnnonceCard'

const blue = {
  50: '#F0F7FF',
  100: '#C2E0FF',
  200: '#80BFFF',
  300: '#66B2FF',
  400: '#3399FF',
  500: '#182952',
  600: '#0072E5',
  700: '#0059B2',
  800: '#004C99',
  900: '#003A75',
};

const Tab = styled(TabUnstyled)`

  color: #707070;
  cursor: pointer;
  font-size: 19px;

  background-color: transparent;
  width: 100%;
  padding: 20px 16px;
  margin: 0; 
  border: none;
 
  display: flex;
  justify-content: center;
  &:focus {
   
  
  }

  &.${tabUnstyledClasses.selected} {

    color: ${blue[500]};
    border-bottom : ${blue[500]} solid 4px;
    font-weight: 700;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 320px;

  border-bottom : #707070  solid 2px;
  margin-bottom: 13px;

  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;




class DashTab extends Component {
    constructor(props) {
        super(props);
        this.state ={
            items : this.props.items,
            content : this.props.content
        }
    }
   
    
    componentDidMount(){
      this.state ={
        items : this.props.items,
        content : this.props.content 
    }
    }
    render() {
        const nested = this.props.nested
        const HOST_NAME = process.env.REACT_APP_SERVER_URL
        const announces = this.state.content.map((c,i)=>{
          if (nested) {
            return c.map(item=>{
              if (i===0) {
                return (
                  <AnnonceCard 
                  key={item}
                  rating={item.rating}
                  imgPath={`${HOST_NAME}/api/announces/${item.photos[0]}/avatar/0`}
                  linkPath={`/hebergement/${item._id}/details`}
                  hotelName={item.title}
                  place={"Dubaii"}
                  map={item.region}
                  idcard={item._id}
                  type = {item.type}
                  />
                  )
              }
              else if(i===4){
                return (
                  <AnnonceCard 
                  key={item}
                  rating={item.rating}
                  imgPath={`${HOST_NAME}/api/announces/${item.photos[0]}/avatar/0`}
                  linkPath={`/hebergement/${item._id}/details`}
                  hotelName={item.title}
                  place={"Dubaii"}
                  map={item.region}
                  idcard={item._id}
                  type = {item.type}
                  />
                  )
              }
            })
          }
          else return (<TabPanel value={i}>{c}</TabPanel>)
        })

        return (
            <>
               <TabsUnstyled defaultValue={0} key={this.props.items}>
               
                      <TabsList >
                      
                          {this.state.items.map((item) => <Tab disabled ={typeof item !== "string"}>{item}</Tab>)}
                          {this.props.search && (
                              <div className=" d-flex justify-content-end pr-0 col-3">
                                 <input type="text" className='animated__search'  placeholder="Search.." />
                              </div>
                          )}
                          {this.props.small && (
                              <div className='col-4'>
                                {announces}
                              </div>
                          )}
                          
                           
                      </TabsList>
                     
               
                  <div className="d-flex mt-5">
                     {announces}
                  </div>    
                </TabsUnstyled> 
            </>
        );
    }
}

export default DashTab;